module.exports = __webpack_public_path__ + "img/jz.a1a79a6d.svg";